import { Identifiable, Project, Zone } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function moveProjects(httpClient: HttpClient) {
  return (projects: Identifiable<Project>[], destination: Identifiable<Zone>) =>
    httpClient.sendHttpRequest<void>({
      endpoint: `/projects/change-zone/${destination.uuid}`,
      method: HttpMethods.PATCH,
      data: { projectsUuids: projects.map(({ uuid }) => uuid) },
    });
}

export { moveProjects };
